import gql from 'graphql-tag';

export default gql`
  mutation orderImportForStores($input: ImportOrderForStoresInput!) {
    orderImportForStores(input: $input) {
      order
      errorMessage
    }
  }
`;
